<template>
  <div class="main-card sn-content">
    <el-button v-if="$route.query.userId" size="mini" class="pxy-primary return-button" style="margin-right: 10px;" @click="$router.go(-1)">返回</el-button>
    <el-card class="box-card clearfix">
      <!-- <el-row style="marginBottom:15px;">
        <el-col :xs="12" :sm="4">托管应用列表</el-col>
      </el-row> -->
      <el-row v-if="$route.query.userId" style="margin-bottom: 20px;">
        <span>用户名称：</span>
        <el-tag effect="plain">{{$route.query.userName}}</el-tag>
      </el-row>
      <el-table :data="appliList">
        <el-table-column prop="appliId" label="应用Id"></el-table-column>
        <el-table-column prop="appliName" label="应用名称"></el-table-column>
        <el-table-column label="计费模式">
          <template slot-scope="scope">
            <span v-if="scope.row.chargeType == 2"> 按量付费</span>
            <span v-if="scope.row.chargeType == 1"> 包月</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1"> 有效</span>
            <span class="danger" v-if="scope.row.status == 0"> 无效</span>
          </template>
        </el-table-column>
        <el-table-column label="应用类型">
          <template slot-scope="scope">
            <span v-if="scope.row.appliType=='1'">   独占 </span>
            <span v-if="scope.row.appliType=='2'">  3D共享 </span>
            <span v-if="scope.row.appliType=='14'">  2D共享 </span>
            <span v-if="scope.row.appliType=='3'">   VR(SteamVR) </span>
            <span v-if="scope.row.appliType=='5'">  VR(SteamVR:Need Steam) </span>
            <span v-if="scope.row.appliType=='7'">  VR(OpenXR) </span>
            <!--  <span v-if="scope.row.appliType=='9'">   AR(PXY) </span>-->
            <span v-if="scope.row.appliType=='11'">   AR(Nvidia) </span>
          </template>
        </el-table-column>
        <el-table-column label="是否开启数据通道">
          <template slot-scope="scope">
            <span v-if="scope.row.dcs == '1'"> 是</span>
            <span v-if="scope.row.dcs == '0'"> 否</span>
          </template>
        </el-table-column>
        <el-table-column label="是否开启互动模式">
          <template slot-scope="scope">
            <span v-if="scope.row.playMode == '1'"> 是</span>
            <span v-if="scope.row.playMode == '0'"> 否</span>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间">
          <template slot-scope="scope">
            {{scope.row.createDate | formatDate}}
          </template>
        </el-table-column>
        <el-table-column
          label="操作" width="150px">
          <template slot-scope="scope">

            <div >
              <div v-if="scope.row.isWebGL == 0 && scope.row.syncingFlag != null && scope.row.syncingFlag" style="float: left">
                <span>同步中<i class="el-icon-loading"></i></span>
              </div>
              <el-button v-else class="pvt-color" type="text" style="position: relative;z-index: 999;" @click="showTip(scope.row.appliId)">
                进入
              </el-button>
              <!--  <el-link type="primary" target="_blank" :href="$apiUrl+'/pocAppli/start?appliId='+scope.row.appliId">进入</el-link>-->
              <el-divider direction="vertical"></el-divider>
              <el-dropdown :hide-on-click="false" @command="handleCommand" @visible-change="dropdownVisibleFn($event,scope.$index)">
              <span class="el-dropdown-link pointer ">
                更多<i class="el-icon-arrow-down el-icon--right pointer"></i>
              </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item   style="position:relative;" :command="{val:'qr',appliId:scope.row.appliId,index:scope.$index}">
                    <span>二维码</span>
                    <div v-if="scope.row.snVisible" style="position:absolute;left: -90px;top: 0;" class="qrcode" :ref="'qrcodeContainer'+scope.$index"></div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link
                      style="color: #333"
                      class="router-link-btn"
                      :to="{ path: '/appli/update', query: { appliId: scope.row.appliId,userName: $route.query.userName,redirect:'/appli/index'}}">
                      编辑
                    </router-link>
                  </el-dropdown-item>
                  <el-dropdown-item  >

                    <el-input  :id="'url'+scope.row.appliId" :value="$apiUrl+'/pocAppli/start?appliId='+scope.row.appliId"  style="position: absolute;opacity: 0;z-index: -1">
                    </el-input>
                    <el-button   type="text" style="color: #333;position: relative;z-index: 999;" @click="copyUrl(scope.row.appliId)">
                      复制链接
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item > <el-button :disabled="scope.row.playMode == '0'" type="text" style="color: #333" @click="openPlayerMode(scope.row.appliId)">互动模式</el-button></el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown>
            </div>

          </template>
        </el-table-column>

      </el-table>
      <PageComponent ref="pageInfo"></PageComponent>
    </el-card>
    <el-dialog
      title="互动模式"
      :visible.sync="playerModeDialogVisible"
      custom-class="player-mode pxy-dialog"
      :close-on-click-modal="false"
      @close="clearplayerMode()"
      center>

      <el-form ref="form" :model="playerModeForm" label-width="80px">
        <!--模式-->
        <el-form-item label="模式">
          <el-radio-group v-model="playerModeForm.playerMode">
            <!--//互动模式-->
            <el-radio label="1"> 互动模式</el-radio>
            <!-- 协作模式-->
            <el-radio label="2">协作模式</el-radio>
          </el-radio-group>
        </el-form-item>
        <!--角色-->
        <el-form-item label="角色">
          <el-radio-group v-model="playerModeForm.role"
                          @change="userTypeChange($event)">
            <!--//演示模式-->
            <el-radio label="1">主控端</el-radio>
            <!-- 观看模式-->
            <el-radio label="0">从控端</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 昵称-->
        <el-form-item label="昵称">
          <el-input v-model="playerModeForm.nickname"></el-input>
        </el-form-item>
        <!--验证方式-->
        <el-form-item v-if="playerModeForm.role == '0'" label="验证方式">
          <el-radio-group v-model="playerModeForm.secretType">

            <!-- 口令模式-->
            <el-radio label="0" selected>口令</el-radio>
            <!--//任务Id-->
            <el-radio label="1">TaskId</el-radio>
          </el-radio-group>
        </el-form-item>
        <!--   口令-->
        <el-form-item
          :label="playerModeForm.secretType == '0'?'口令':'TaskId'">
        <span v-if="playerModeForm.role == '1'">
          <el-button type="primary" size="small" icon="el-icon-key" v-if="playerModeForm.roomCode == ''"
                     @click="createRoomCode()">生成口令</el-button>
    <el-input id="roomCode" readonly v-if="playerModeForm.roomCode != ''" v-model="playerModeForm.roomCode">
      <!--复制-->
          <el-button slot="append" @click="copyRoomCode()">复制</el-button>
  </el-input>

        </span>
          <el-input v-if="playerModeForm.role == '0' && playerModeForm.secretType == '0'"
                    v-model="playerModeForm.roomCode">
          </el-input>
          <el-input v-if="playerModeForm.role == '0' && playerModeForm.secretType == '1'"
                    v-model="playerModeForm.taskId">
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <!-- <el-link type="primary" target="_blank" :href="$apiUrl+'/pocAppli/start?appliId='+playerModeForm.appliId+'&playerMode='+playerModeForm.playerMode+'&role='
           +playerModeForm.role+'&nickname='+playerModeForm.nickname+
           playerModeForm.secretType == '0' ? '&roomCode='+playerModeForm.roomCode : '&taskId='+playerModeForm.taskId">进入</el-link>-->
          <el-button type="primary" size="small" @click="enterAppliByPlayerMode()">
            生成
          </el-button>
        </el-form-item>
        <el-form-item label="链接：" style="display: none" id="playerModeUrlArea">
          <el-input  id="playerModeUrl" v-model="playerModeForm.url">
            <el-button slot="append" @click="copyPlayerModeUrl()">复制</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <!--  </el-col>
      </el-row>-->
    </el-dialog>

  </div>
</template>

<script>
  import {Message} from "element-ui";
  import PageComponent from '@/components/pageInfo/PageComponent'

  export default {
    components: {PageComponent},
    data() {
      return {
        playerModeDialogVisible:false,
        playerModeForm: {
          appliId:"",
          playerMode: "1",
          role: "1",
          nickname: '',
          roomCode: '',
          secretType: '0',
          taskId: '',
          url:''
        },
        appliList: [],
        appliCnt: 0,
        userQuotaForSn: {},
      }
    },
    created() {

    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    methods: {
      getAppliList: function () {
        var params = {};
        params.userId = this.$route.query.userId;
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        this.getRequest('/pocAppli/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.appliList = resp.data.result.records;
              this.appliCnt = resp.data.result.total;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      showTip(appliId){
        var that = this;
        this.$confirm('托管应用为按量计费模式；即:进入应用开始计费，退出应用结束计费；当使用结束时请关闭网页退出应用', '温馨提示', {
          confirmButtonText: '进入',
          cancelButtonText: '关闭',
          type: 'warning',
          center: true
        }).then(() => {
          var url =  that.$apiUrl+'/pocAppli/start?appliId='+appliId
          window.open(url)
        }).catch(() => {

        });
      },
      // 更多-下拉菜单隐藏时，把当前二维码图片隐藏掉
      dropdownVisibleFn(val,index) {
        if(val) {
          this.$set(this.appliList[index],'snVisible', true);
        } else {
          this.$set(this.appliList[index],'snVisible', false);
        }
      },
      copyUrl(appliId) {
        var id = "url"+appliId;
        let text = document.getElementById(id);
        text.select();
        document.execCommand('Copy');
        this.$message({type: 500, message: "复制成功"});
      },
      openPlayerMode: function (appliId) {
        this.playerModeDialogVisible = true;
        this.playerModeForm.appliId = appliId;
      },
      handleCommand(command) {
        if(command) {
          const _this = this;
          if(command.val == 'qr') {
            _this.$nextTick(() => {
              _this.getWXEWM(command.appliId,command.index);
            })
          }
        }

      },
      getWXEWM(appliId,index) {
        $(".qrcode").html("");
        let qrCode = new QRCode(this.$refs['qrcodeContainer'+index],{
          width:100,
          height:100,
          colonDark: '#000',
          colonLight: '#fff',
          text: this.$apiUrl+'/pocAppli/start?appliId='+appliId
        })
      },
    },
    mounted: function () {
      this.getAppliList();
      this.$refs.pageInfo.initPagenator(this.getAppliList, null);
    },
    beforeDestroy() {

    }
  }
</script>
